// extracted by mini-css-extract-plugin
export var history = "company-history-module--history--IHy2Y";
export var arrow = "company-history-module--arrow--3lqta";